// 关于二维码标签

import * as types from '../mutation-types.js'

// state
const state = {
  qrlabelList: []
}

// getters
const getters = {
  qrlabelList: state => {
    return state.qrlabelList
  }
}

// actions
const actions = {
  // 初始化二维码列表
  initQrlabelList ({commit}, qrlabelList) {
    commit(types.QR_LABEL_LIST_INIT, qrlabelList)
  },
  // 添加一个二维码标签
  addOneQrlabel ({commit}, newQrlabel) {
    commit(types.QR_LABEL_ADD_ONE, newQrlabel)
  },
  // 删除一个二维码标签
  deleteOneQrlabel ({commit}, qrlabelId) {
    commit(types.QR_LABEL_DELETE_ONE, qrlabelId)
  },
  // 更新一个二维码标签
  updateOneQrlabel ({commit}, qrlabel) {
    commit(types.QR_LABEL_UPDATE_ONE, qrlabel)
  },
  // 为某个标签下的num添加1，即在给一个二维码添加标签时调用（将某个标签下的num加1）
  labelNumAddOne ({commit, state}, qrlabelId) {
    let lb = state.qrlabelList.find(function (item) {
      return item.id === qrlabelId
    })
    if (lb !== undefined) {
      // lb = {...lb, num: lb.num + 1}
      lb.num = lb.num + 1
      // TODO: 这里可能存在一些问题，lb实际上是对象，qrlabelList中实际上已经更新，但是不知道是否有其他更加nice的方法
      commit(types.QR_LABEL_UPDATE_ONE, lb)
    }
  },
  // 为某个标签下的num减少1，即在给一个二维码去掉标签时调用（将某个标签下的num减1）
  labelNumMinusOne ({commit, state}, qrlabelId) {
    let lb = state.qrlabelList.find(function (item) {
      return item.id === qrlabelId
    })
    if (lb !== undefined) {
      if (lb.num > 0) {
        lb = {...lb, num: lb.num - 1}
        // TODO: 这里可能存在一些问题，lb实际上是对象，qrlabelList中实际上已经更新，但是不知道是否有其他更加nice的方法
        commit(types.QR_LABEL_UPDATE_ONE, lb)
      }
    }
  }
}

// mutations
const mutations = {
  [types.QR_LABEL_LIST_INIT] (state, qrlabelList) {
    state.qrlabelList = qrlabelList
  },
  [types.QR_LABEL_ADD_ONE] (state, newQrlabel) {
    state.qrlabelList.push(newQrlabel)
  },
  [types.QR_LABEL_DELETE_ONE] (state, qrlabelId) {
    // 查找哪个满足id，并删除
    let idx = state.qrlabelList.findIndex(function (e) {
      return e.id === qrlabelId
    })
    if (idx !== -1) {
      state.qrlabelList.splice(idx, 1)
    }
  },
  [types.QR_LABEL_UPDATE_ONE] (state, qrlabel) {
    // 查找原有标签所在位置，并替换
    let idx = state.qrlabelList.findIndex(function (e) {
      return e.id === qrlabel.id
    })
    if (idx !== -1) {
      state.qrlabelList.splice(idx, 1, qrlabel)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
